var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVideoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 16.07c-.8-.46-1.26-1.4-1.26-2.59v-2.96c0-1.18.46-2.13 1.26-2.59.8-.46 1.84-.39 2.87.21l2.57 1.48c1.02.59 1.61 1.46 1.61 2.38 0 .92-.59 1.79-1.61 2.38l-2.57 1.48c-.58.34-1.17.51-1.71.51-.42 0-.81-.1-1.16-.3zm.76-6.84c-.32.19-.51.66-.51 1.29v2.96c0 .63.18 1.1.51 1.29.32.19.82.11 1.37-.21l2.57-1.48c.55-.32.86-.71.86-1.08 0-.37-.31-.77-.86-1.08l-2.57-1.48c-.36-.21-.69-.31-.96-.31-.16 0-.3.03-.41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12C1.25 6.07 6.07 1.25 12 1.25S22.75 6.07 22.75 12 17.93 22.75 12 22.75 1.25 17.93 1.25 12zm1.5 0c0 5.1 4.15 9.25 9.25 9.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75 2.75 6.9 2.75 12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoCircle);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-circle.d5db8a65be4eddcbcf32b471c846f0ea.svg";
export { ForwardRef as ReactComponent };